// Abre en otra pestaña un PDF que se pide al backend (respuesta { status, blob } de payslipService/myPayslipService).
// La pestaña se abre antes del pedido para que el navegador no la bloquee como popup; si falla, se cierra.
export function openPdfInNewTab(request) {
  const tab = window.open("", "_blank");
  return request
    .then((response) => {
      if (response.status) {
        const url = URL.createObjectURL(response.blob);
        if (tab) tab.location.href = url;
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } else if (tab) {
        tab.close();
      }
      return response;
    })
    .catch((e) => {
      if (tab) tab.close();
      throw e;
    });
}
